import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=814f164e&scoped=true"
import script from "./placeOrder.vue?vue&type=script&lang=js"
export * from "./placeOrder.vue?vue&type=script&lang=js"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=814f164e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814f164e",
  null
  
)

export default component.exports